import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenAdjustmentPage } from '@/features/product/pages/SpecimenAdjustmentPage';
import { specimenDistributionSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/specimen-adjustment')({
  validateSearch: specimenDistributionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen Adjustment">
      <Suspense fallback={<PageLoader />}>
        <SpecimenAdjustmentPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
